import $ from 'jquery';
import Swal from 'sweetalert2';
import { getCookie } from '@/router/index.js';

export default {
  name: 'ResetEmailSent',
  data: () => ({
    email: sessionStorage.getItem('reset_email') || '',
    countdown: 15,
    is_resend_disabled: true,
    timer: null,
    base_time: 15,
  }),
  mounted() {
    this.start_timer();
    this.csrfToken = getCookie("csrftoken");
  },
  beforeUnmount() {
    this.clear_timer();
  },
  methods: {
    start_timer() {
      this.is_resend_disabled = true;
      this.clear_timer();
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.clear_timer();
          this.is_resend_disabled = false;
        }
      }, 1000);
    },
    clear_timer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    reset_timer() {
      this.is_resend_disabled = true;
      this.clear_timer();
      this.base_time += 5;
      this.countdown = this.base_time;
      this.start_timer();
    },
    resend_email() {
      if (this.is_resend_disabled || this.countdown > 0 || !this.email) return;

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/forgot_password/';
      const cookie_url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_csrf_token/';

      this.is_resend_disabled = true;

      $.ajax({
        url: cookie_url,
        method: 'GET',
        crossDomain: true,
        xhrFields: { withCredentials: true },
      })
      .always(() => {
        this.csrfToken = getCookie('csrftoken') || this.csrfToken;

        const headers = {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        };
        if (this.csrfToken) {
          headers['X-CSRFToken'] = this.csrfToken;
        }

        $.ajax({
          url: url,
          method: 'POST',
          dataType: 'json',
          crossDomain: true,
          xhrFields: { withCredentials: true },
          headers: headers,
          data: JSON.stringify({ email: this.email }),
          success: (data) => {
            if (data && data.status === 'success') {
              Swal.fire('Sent', 'We’ve resent the reset link to your email.', 'success');
              this.reset_timer();
            } else {
              const msg = (data && data.message) || 'Failed to resend email.';
              this.is_resend_disabled = false;
              Swal.fire('Error', msg, 'error');
            }
          },
          error: (xhr) => {
            const msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to resend email. Please try again.';
            this.is_resend_disabled = false;
            Swal.fire('Error', msg, 'error');
          },
        });
      });
    },
},
};